import React from 'react'
import PropTypes from 'prop-types'
import SadIcon from 'src/assets/icons/sad.svg'
import MailIcon from 'src/assets/icons/email.svg'
import SmileIcon from 'src/assets/icons/smile.svg'
import PhoneIcon from 'src/assets/icons/phone.svg'
import CheckIcon from 'src/assets/icons/check.svg'
import PencilIcon from 'src/assets/icons/pencil.svg'
import SaveIcon from 'src/assets/icons/save_alt.svg'
import LoadingIcon from 'src/assets/icons/loading.svg'
import CardIcon from 'src/assets/icons/credit_card.svg'
import BrokenIcon from 'src/assets/icons/broken_image.svg'
import BackArrowIcon from 'src/assets/icons/arrow_back.svg'
import FormSelectIcon from 'src/assets/icons/form-select.svg'
import SelectArrows from 'src/assets/icons/select-arrows.svg'
import ForwardArrowIcon from 'src/assets/icons/arrow_forward.svg'
import SearchIcon from 'src/assets/icons/search.svg'
import SearchIconLoading from 'src/assets/icons/search-loading.svg'
import SearchNoResultsIcon from 'src/assets/icons/search-no-results.svg'
import CloseIcon from 'src/assets/icons/close.svg'
import Flower from 'src/assets/icons/flower.svg'
import FlowerMcColls from 'src/assets/icons/flower-mccolls.svg'
import OpenNewWindowIcon from 'src/assets/icons/open-new.svg'
import LocationIcon from 'src/assets/icons/location.svg'
import FunnelIcon from 'src/assets/icons/funnel.svg'
import FilterIcon from 'src/assets/icons/filter.svg'
import LocationPinIcon from 'src/assets/icons/locationpin.svg'
import GoogleLiveIcon from 'src/assets/icons/google-live.svg'
import InfoIcon from 'src/assets/icons/info.svg'
import InfoNewStoreIcon from 'src/assets/icons/info-v2.svg'
import ErrorIcon from 'src/assets/icons/error.svg'
import ParkingIcon from 'src/assets/icons/parking-icon.svg'

const propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
}

const Icon = ({ icon, className, ariaLabel }) => {
  let iconComponent
  switch (icon) {
    case 'mail':
      iconComponent = (
        <MailIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'mail'}
        />
      )
      break
    case 'pencil':
      iconComponent = (
        <PencilIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'edit'}
        />
      )
      break
    case 'phone':
      iconComponent = (
        <PhoneIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'phone'}
        />
      )
      break
    case 'card':
      iconComponent = (
        <CardIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'card'}
        />
      )
      break
    case 'forwardArrow':
      iconComponent = (
        <ForwardArrowIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'proceed'}
        />
      )
      break
    case 'formSelect':
      iconComponent = (
        <FormSelectIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'satisfied'}
        />
      )
      break
    case 'smile':
      iconComponent = (
        <SmileIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'satisfied'}
        />
      )
      break
    case 'sad':
      iconComponent = (
        <SadIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'dissatisfied'}
        />
      )
      break
    case 'backArrow':
      iconComponent = (
        <BackArrowIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'back'}
        />
      )
      break
    case 'loading':
      iconComponent = (
        <LoadingIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'selectArrows':
      iconComponent = (
        <SelectArrows
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'satisfied'}
        />
      )
      break
    case 'check':
      iconComponent = (
        <CheckIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'check'}
        />
      )
      break
    case 'save':
      iconComponent = (
        <SaveIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'check'}
        />
      )
      break
    case 'searchIconLoading':
      iconComponent = (
        <SearchIconLoading
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'searchIcon':
      iconComponent = (
        <SearchIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'searchNoResults':
      iconComponent = (
        <SearchNoResultsIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'close':
      iconComponent = (
        <CloseIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'flower':
      iconComponent = (
        <Flower
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'loading'}
        />
      )
      break
    case 'flowermccolls':
      iconComponent = (
        <FlowerMcColls
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'flowermccolls'}
        />
      )
      break
    case 'opennewwindow':
      iconComponent = (
        <OpenNewWindowIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'opennewwindow'}
        />
      )
      break
    case 'location':
      iconComponent = (
        <LocationIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'location'}
        />
      )
      break
    case 'funnel':
      iconComponent = (
        <FunnelIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'funnel'}
        />
      )
      break
    case 'filter':
      iconComponent = (
        <FilterIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'filter'}
        />
      )
      break
    case 'locationpin':
      iconComponent = (
        <LocationPinIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'locationpin'}
        />
      )
      break
    case 'googlelive':
      iconComponent = (
        <GoogleLiveIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'googlelive'}
        />
      )
      break
    case 'info':
      iconComponent = (
        <InfoIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'info'}
        />
      )
      break
    case 'infonewstore':
      iconComponent = (
        <InfoNewStoreIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'infonewstore'}
        />
      )
      break
    case 'error':
      iconComponent = (
        <ErrorIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'error'}
        />
      )
      break
    case 'parkingicon':
      iconComponent = (
        <ParkingIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'parkingicon'}
        />
      )
      break
    default:
      iconComponent = (
        <BrokenIcon
          className={className}
          aria-label={ariaLabel ? ariaLabel : 'broken'}
        />
      )
      break
  }
  return iconComponent
}

Icon.propTypes = propTypes

export default Icon
